module.exports = __webpack_public_path__ + "static/img/084.48b805f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/084.png
// module id = Ulaa
// module chunks = 0